export default {
  init() {

    // JavaScript to be fired on all pages
    // eslint-disable-next-line no-undef
    if(parseInt(ajax_vars.load_extend_session) === 1) {

      setInterval(function () {

        // eslint-disable-next-line no-undef
        $.post(ajax_vars.ajax_url, {action: "extend_session"}, function (response, status, jqXHR) {

          if (jqXHR.status != 200 || response == "false" || typeof (response.success) === "undefined"  || response.success == 0) {
            return window.location = location.protocol + "//" + location.host + "/login/";
          }

        }, "JSON");

      }, 300000);

    }

    function _resetMenu() {
      $(".c-nav-item.active").removeClass("active").find(".dropdown-menu").slideToggle();
    }

    $(window).resize(_resetMenu);
    $(window).scroll(_resetMenu);

    $(document).ready(function() {
      $(".main-menu-trigger").on("click", function() {
        _resetMenu();
        $("body").toggleClass("modal-open");
        $(".c-navbar").toggleClass("main-menu-active");
      });

      $(".user-menu-trigger").on("click", function() {
        _resetMenu();
        $("body").toggleClass("modal-open");
        $(".c-navbar").toggleClass("user-menu-active");
      });

      $(".c-nav-item.has-dropdown").on("click", function(event) {
        if(!$(event.currentTarget).hasClass("active")) {
          _resetMenu();
        }

        if ($(event.currentTarget).hasClass("active")) {
          $(event.currentTarget).removeClass("active");
          $(event.currentTarget).find(".dropdown-menu").slideToggle();
        } else {
          $(event.currentTarget).addClass("active");
          $(event.currentTarget).find(".dropdown-menu").slideToggle();
        }
      });

    });

    $(".close-banner").click(function(){
      $(".download-app-banner").slideUp();
    });

    /**
     * Short pricing list by specific location 
     * Show/hide more prices button on click
     */
    $(".btn-view-more").on('click', function(e){
      e.preventDefault();
      var hiddenRows = $(".hide-service-row");
      var showHideText = $('#show-hide-btn-text');

      hiddenRows.slideDown();
      showHideText.text('Hide');

      if (!hiddenRows.length){
        hiddenRows = $(".show-service-row")
        hiddenRows.slideUp();
        showHideText.text('Show');
      }

      hiddenRows.toggleClass('hide-service-row show-service-row')
    });

    if (document.getElementById('mulberrys-alert')) {
      window.setTimeout(function () {
        $("#mulberrys-alert").fadeOut('slow');
      }, 15000);
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js